import { createContext, useContext, useState } from 'react';
import { translations } from './translations';

const I18nContext = createContext(null);

export const LANGS = [
  { id: 'fr', label: 'FR' },
  { id: 'en', label: 'EN' },
  { id: 'es', label: 'ES' },
];

export const DATE_LOCALES = { fr: 'fr-FR', en: 'en-GB', es: 'es-ES' };

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem('ocqj_lang');
    return LANGS.some((l) => l.id === saved) ? saved : 'fr';
  });

  const setLang = (l) => {
    localStorage.setItem('ocqj_lang', l);
    setLangState(l);
  };

  const t = (key, vars, fallback) => {
    let s = translations[lang]?.[key] ?? translations.fr[key] ?? fallback ?? key;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        s = s.replaceAll(`{${k}}`, String(v));
      });
    }
    return s;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t, dateLocale: DATE_LOCALES[lang] }}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
